var lib_core                = require("lib-core"); 
var THREE                   = require("three"); 

var AbstractMoveable3dObjectModel = function () {
    lib_core.Model.call(this);

    this.moveable = true;
    this.movementPlane = new THREE.Plane(new THREE.Vector3(0,0,1));

    this.hoverable = true;
    this.hovered = this.value("hovered", true);
};

lib_core.inherit(AbstractMoveable3dObjectModel, lib_core.Model);
AbstractMoveable3dObjectModel.$class = "AbstractMoveable3dObjectModel";
module.exports = AbstractMoveable3dObjectModel;

AbstractMoveable3dObjectModel.prototype.createMovementPlane = function(ray, point){
    this.movementPlane.setComponents(0, 0, -1, point.z);
}

AbstractMoveable3dObjectModel.prototype.createMovementPlane = function(ray, point){}

AbstractMoveable3dObjectModel.prototype.setContactPosition = function(position){}

AbstractMoveable3dObjectModel.prototype.setMousePosition = function(position){}

AbstractMoveable3dObjectModel.prototype.released = function(position){}


// the position is the offset of the objects position when contacted with the current mouse
//  (you could do this yourself with the above two functions but its just what you usually need,
//      so why not :)  BUT!!!! you must use both these functions together
AbstractMoveable3dObjectModel.prototype.setOffsetPosition = function(position){}
        //  !!!!! if getPosition is not filled out setOffsetPosition won't be called !!!
AbstractMoveable3dObjectModel.prototype.getPosition = function(){}
